import groupModel from './groupModel';
import { controlComponentsList, delControlComponents, delComponentsInfo } from './../request';
import informationModel from './../../components/informationModel';
export default {
  components: {
    groupModel,
    informationModel
  },
  data() {
    return {
      form: {
        name: '',
        controlsId: this.$route.params.id
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: 'icon'
        },
        dataIndex: 'icon',
        key: '2',
        align: 'center',
        width: 90,
        scopedSlots: {
          customRender: 'icon'
        }
      }, {
        slots: {
          title: '组件名称'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '组件标识'
        },
        dataIndex: 'mark',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 200,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      groupShow: false,
      informationShow: false,
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await controlComponentsList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    handleEdit(val) {
      this.groupShow = true;
      this.$nextTick(() => {
        this.$refs.groupRef.init(val);
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async handleDelete(val) {
      const res = await delComponentsInfo({
        componentsId: val.id
      });
      console.log(res);
      if (res.length != 0) {
        this.informationShow = true;
        this.$nextTick(() => {
          this.$refs.informationRef.init(res, 1);
        });
        return false;
      }
      let _this = this;
      this.$alert(_this.$t('是否确认删除该组件？'), {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delControlComponents({
          componentsId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    }
  }
};